module.exports = __webpack_public_path__ + "static/media/clear.b4c406bb.svg";